import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import './Libraries/fontawesome/all.min.css';
import {BrowserRouter} from 'react-router-dom';
import Store from './redux/store';
import { Provider } from 'react-redux';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

<BrowserRouter>
        <Provider store={ Store}>    
        <App />
        </Provider>
        
</BrowserRouter>
);


reportWebVitals();
